<template>
    <el-dialog :title="'图片预览'" :close-on-click-modal="false" :append-to-body="true" width="70%" :visible.sync="viewData.visible">
        <el-row align="middle" justify="center">
            <el-col :span="12">
                <el-tag type="info">{{fileName}}</el-tag>
            </el-col>
        </el-row>
        <div class="block" align="center" >
            <el-image :src="url"></el-image>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="viewData.visible = false">关闭
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
  import Vue from 'vue'
  export default {
    data() {
      return {
        file:{},  
        viewData: {
            visible: false,
            width: ""
        },
        url: '',
        fileName: ''
      }
    },
    methods: {
        init(fileUrl, fileName) {
            this.viewData.visible = true
            this.url = fileUrl
            this.fileName = fileName
        },
    }
  }

</script>
<style lang="scss">

</style>